'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".SelectList-module_select__Vo5eh{border:.0625rem solid #999;border-radius:.125rem;color:#666;cursor:auto;font-size:.875rem;height:2.5rem;min-width:6.25rem;outline-width:0;padding-left:.75rem;padding-right:.75rem;width:100%}.SelectList-module_selectDisabled__yLMxV{border-color:#e0e0e0;color:#e0e0e0;cursor:not-allowed}";
var styles = {"select":"SelectList-module_select__Vo5eh","selectDisabled":"SelectList-module_selectDisabled__yLMxV"};
styleInject["default"](css_248z, '6a52cc35-06fe-4dbe-bc7b-41b71cfb97f4');

exports["default"] = styles;
